/**
 * Which mission fields a contract carries (JBWEB-1141).
 *
 * Changing one of the fields below updates Jobbiz and nothing else: no BeSTT
 * patch, no signature to send again, no amendment. Every other field is on the
 * contract, so changing it has consequences that depend on the contract's state.
 *
 * The planning is here by decision, not by accident: BeSTT prints it on the
 * contract, but the printed hours are indicative — the timesheet is what counts,
 * and a client changes the planning mid-mission often enough that re-issuing the
 * contract for it would be absurd. The api still patches it onto a contract that
 * has gone nowhere, where no signature is at stake; nothing changes here, since
 * this list is about what needs an amendment or a signature.
 *
 * Twin of api/useCases/admin/updateMissionDetails.usecase.js. The two lists must
 * say the same thing: the front decides what to warn about, the back decides
 * what to do.
 */
export const NON_CONTRACT_IMPACTING_FIELDS = new Set([
  'reference',
  'other', // informations pour le candidat
  'other_interim', // informations pour l'agence
  'languages',
  'schedule', // planning
  'dressCode',
  // The BeSTT contract prints the contact's name, but by decision a contract
  // already generated keeps the old one: it is neither patched nor amended.
  'contact',
  // Who provides each tool: only the names (`tools`) reach BeSTT.
  'toolProviders',
  // The tasks are on the mission sheet only; BeSTT has no field for them.
  'tasks',
]);

export const isContractImpactingChange = (change) =>
  !NON_CONTRACT_IMPACTING_FIELDS.has(change?.field);
